<!-- <app-loader *ngIf="isLoading()" /> -->
<div class="dialog-header">
    <h6>{{ isEditMode ? 'Edit Service' : 'Add Service' }}</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form [formGroup]="serviceForm" (ngSubmit)="onSubmit()">

    <div class="service-section">
        <mat-form-field appearance="outline" class="service-field">
            <mat-label>Service</mat-label>
            <input matInput formControlName="service_name" />
            <!-- <mat-error *ngIf="serviceForm.get('service_name')?.hasError('required')">
                Service name is required.
            </mat-error> -->
        </mat-form-field>

        <button mat-raised-button type="button" class="add-column-btn" (click)="addField()">
            <span>Add Columns</span>
            <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
        </button>
        <button mat-flat-button color="primary" class="save-service-btn" type="submit">
            {{ isEditMode ? 'Update Service' : 'Add Service' }}
        </button>
    </div>

    <!-- SCROLLABLE vessel fields-->
    <div formArrayName="fields" class="scroll-vessel-fields">
        <div *ngFor="let field of fields.controls; let i = index" [formGroupName]="i" class="vessel-card">


            <div class="vessel-card-content">
                <mat-form-field appearance="outline" class="field-input">
                    <mat-label>Field Name</mat-label>
                    <input matInput placeholder="Enter field name" formControlName="name" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field-input">
                    <mat-label>Data Type</mat-label>
                    <mat-select formControlName="data_type">
                        <mat-option value="string">Text</mat-option>
                        <mat-option value="number">Number</mat-option>
                        <mat-option value="decimal">Decimal</mat-option>

                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="field-input">
                    <mat-label>Required</mat-label>
                    <mat-select formControlName="nullable">
                        <mat-option [value]="false">Required</mat-option>
                        <mat-option [value]="true">Optional</mat-option>
                    </mat-select>
                </mat-form-field>

                <button mat-icon-button (click)="removeField(i)" class="delete-button" type="button">
                    <mat-icon fontSet="material-symbols-outlined" class="delete-icon">delete</mat-icon>
                </button>
            </div>

        </div>
    </div>

    <!--  Custom Validator Error for FormArray -->
    <!-- <div class="error" *ngIf="fields.errors?.atLeastOneFieldRequired && fields.touched"
        style="color: #ba1a1a;  font-size: 11px; word-spacing: -1px; margin-top: 0px;">
        At least one field(Field Name, Data Type) is required.
    </div> -->
    <!-- 
    <div>
        <button mat-flat-button color="primary" class="add-cargo" type="submit"> {{ isEditMode ? 'Update Service' : 'Add
            Service' }}</button>
    </div> -->
</form>